import { Injectable } from '@angular/core';
import { SSOService } from './sso/sso.service';
import { ENPSService } from './enps/enps.service';
import { HttpRequest } from '@angular/common/http';
import { IAuthService } from '../authentication/iauth.service'
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Http, RequestOptionsArgs, ResponseContentType } from '@angular/http';

declare var serverConfig: { [id: string]: any };
const helper = new JwtHelperService({ tokenGetter: () => { } });

@Injectable()
export class AuthService {
    cachedRequests: Array<HttpRequest<any>> = [];

    constructor(private ssoService: SSOService,
        private enpsService: ENPSService,
        private router: Router,
        private http: Http,
    ) { }

    public shouldReload: boolean = false;
    public providerName: string = null;
    public redirectUri: string = null;

    public async authenticate() {
        /*if (type != 'ENPS') {
            if (!token || token == null || token === undefined || token === 'null' || !tokenValid) {
                let res = this.ServiceFactory(type).authenticate();
            }
        } else {*/

        let res = await this.ServiceFactory(this.providerName).authenticate();
        /*if (res.status) {
            if (this.redirectUri) {
                window.location = this.redirectUri + ""
            }
        } else {

        }
        }*/
    }

    private ServiceFactory(type: string): IAuthService {
        switch (type) {
            /*case 'ENPS':
                return this.enpsService;*/
            default:
                return this.ssoService;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/providers/authentication/auth.service.ts